/**
 * LogsTab — user activity log. All behavior lives in the shared
 * ProfileLogsTable; this only supplies what differs per entity.
 *
 * The actor links to their user profile when they belong to this community, except
 * when the actor is this user: their own logins and self-service resets would link to
 * the page already open (selfUserId). Rows fall back to `source` when there is no
 * structured log_info, which is what distinguishes an admin-initiated password reset
 * from a self-service one.
 */

import ProfileLogsTable from '../../../../components/v2/ProfileLogsTable.jsx';

const LogsTab = ({ logData, tzOffset, userId, showInternal = true }) => (
  <ProfileLogsTable
    logData={logData}
    tzOffset={tzOffset}
    typeKey="user_log_type"
    title="User Logs"
    linkUsers
    selfUserId={userId}
    detailFallbackKey="source"
    showInternal={showInternal}
  />
);

export default LogsTab;
